
















































import DictMixin from '@/mixins/dict-mixin';
import { DimensionDto } from '@/services/dimension';
import { mixins } from 'vue-class-component';
import { Vue, Component, PropSync, Prop } from 'vue-property-decorator';

@Component
export default class DimensionForm1 extends mixins(DictMixin) {
  @PropSync('formData') syncFormData!: DimensionDto;
  @Prop() id!: any;

}
